import useAxiosRepository from '../../../repositories/BaseRepository';
import { ApiMarketingCampaignsResponse } from '@/js/marketing-campaigns/types/types';
import { marketingCampaignsApiEndpoints } from '../constants/marketingCampaignsApiEndpoints';

const axiosRepo = useAxiosRepository();

export const fetchMarketingCampaignData = async (
    routeName?: string,
    resourceAlias?: string,
    resourceSlug?: string,
    countryCode?: string,
): Promise<ApiMarketingCampaignsResponse> => {
    const params = {
        route_name: routeName,
        resource_alias: resourceAlias,
        resource_slug: resourceSlug,
        country_code: '',
    };

    if (countryCode) {
        params.country_code = countryCode;
    }

    const queryParams = new URLSearchParams(params);

    return axiosRepo.get(`${marketingCampaignsApiEndpoints.MARKETING_CAMPAIGN}?${queryParams}`);
};
